import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getRemoteConfig } from "firebase/remote-config";

const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG)

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const remoteConfig = getRemoteConfig(app);

window.FIREBASE_APPCHECK_DEBUG_TOKEN = true

const appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6Lc4jBEnAAAAAFEEqViy4WZvrPD08hMi0TA5NE_M'),
    isTokenAutoRefreshEnabled: true
  });

export { app, analytics, auth, db, appCheck, remoteConfig }